import 'css-chunksrc/client/scenes/projectExpenseCreation/styles.scss';export default {
  "form": "_form_18eyy_1",
  "footer": "_footer_18eyy_5",
  "button": "_button_18eyy_13"
};